import api from "./api";
import TokenService from "./token.service";
class AuthService {
  async login({ email, password }) {
    return api
      .post("/auth/signin", {
        email,
        password
      })
      .then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
  }

logout(userId) {
    console.log("Enviando userId:", userId); // Deve mostrar o ID correto
    return api.post('/auth/logout', { userId });
  }

  register({ username, email, password }) {
    return api.post("/auth/signup", {
      username,
      email,
      password
    });
  }

  getToken = async (selectedCompanyId, userId) => {
    try {
      await api.post("/auth/getToken", {
        selectedCompanyId: selectedCompanyId,
        user_id: userId
      }).then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
          console.log(response.data)
        }

        return response.data;
      });
    } catch (error) {
      throw new Error(error.message || "Erro ao obter o token.");
    }
  };

}

export default new AuthService();
